module.exports = __webpack_public_path__ + "static/media/IMG_6391.373225e8.jpg";